module.exports = __webpack_public_path__ + "static/media/don.40a4ba87.webp";